import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  FleetConstantClassCollection,
  UpdateFleetConfigurationRequest,
  UpdateFleetConfigurationResponse,
  ErmDevOpsApiClientService,
  UpdateFleetConfigurationDialogData,
  FleetConfiguration
} from 'erm-sdk';

@Component({
  standalone: false,
  selector: 'app-update-fleet-configuration',
  templateUrl: './update-fleet-configuration.component.html',
  styleUrls: ['./update-fleet-configuration.component.scss']
})
export class UpdateFleetConfigurationComponent {

  isSaving: boolean = false;
  accountId: string;
  fleetConstantClassCollection: FleetConstantClassCollection;
  updateFleetConfigurationRequest: UpdateFleetConfigurationRequest;
  updateFleetConfigurationResponse?: UpdateFleetConfigurationResponse;

  constructor(private ermDevOpsApiClient: ErmDevOpsApiClientService,
    @Inject(MAT_DIALOG_DATA) public updateFleetConfigurationDialogData: UpdateFleetConfigurationDialogData,
    public dialogRef: MatDialogRef<UpdateFleetConfigurationComponent>) {
    let fleetConfiguration = updateFleetConfigurationDialogData.fleetConfigurationDefaults as FleetConfiguration;
    this.accountId = fleetConfiguration.accountId as string;
    this.fleetConstantClassCollection = updateFleetConfigurationDialogData.fleetConstantClassCollection as FleetConstantClassCollection;
    this.updateFleetConfigurationRequest = {
      fleetId: fleetConfiguration.fleetId,
      state: fleetConfiguration.state,
      accessPolicy: fleetConfiguration.accessPolicy,
      priority: fleetConfiguration.priority,
      minLaunchCapacity: fleetConfiguration.minLaunchCapacity
    } as UpdateFleetConfigurationRequest;
  }

  async save(): Promise<void> {
    try {
      this.isSaving = true;
      const updateFleetConfigurationResponse = await this.ermDevOpsApiClient.updateFleetConfiguration(this.updateFleetConfigurationRequest);
      this.updateFleetConfigurationResponse = updateFleetConfigurationResponse.body as UpdateFleetConfigurationResponse;
    } finally {
      this.isSaving = false;
    }
  }

  close(): void {
    this.dialogRef.close({ data: this.updateFleetConfigurationResponse?.fleetConfiguration });
  }
}
